import * as React from 'react'
import { getPageTypeLabel, Operation } from '../domain/Operation'

interface Props {
    transaction: Operation
}

export class TransactionPageType extends React.PureComponent<Props> {
    public render() {
        if (this.props.transaction.pageType == 'unspecified' || !this.props.transaction.pageType) {
            return null
        }

        return (
            <>
                &nbsp;<span className="label label-outline-default">{getPageTypeLabel(this.props.transaction.pageType)}</span>
            </>
        )
    }
}
